export default (type, ...properties) => (...args) => ({
    type,
    ...properties.length && {...Object.assign(...properties.map((propertyName, index) =>
        ({[propertyName]: args[index]})
    ))},
});
